"use strict";

exports.__esModule = true;
exports.default = exports.getCurrentLocale = void 0;

const getCurrentLocale = ({
  registry
}) => {
  const _registry$formContext = registry.formContext,
        languages = _registry$formContext.languages,
        defaultLocale = _registry$formContext.defaultLocale,
        currentLocale = _registry$formContext.currentLocale;
  return currentLocale || defaultLocale || languages && languages.length && languages[0] || undefined;
};

exports.getCurrentLocale = getCurrentLocale;
var _default = getCurrentLocale;
exports.default = _default;